import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 30,
	viewBox: "0 0 31 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.6667 2.5C8.76291 2.5 3.16666 8.09625 3.16666 15C3.16666 21.9037 8.76291 27.5 15.6667 27.5C22.5704 27.5 28.1667 21.9037 28.1667 15C28.1667 8.09625 22.5704 2.5 15.6667 2.5ZM22.8004 12.1337L14.0504 20.8838C13.8067 21.1275 13.4867 21.25 13.1667 21.25C12.8467 21.25 12.5267 21.1275 12.2829 20.8838L8.53291 17.1337C8.04416 16.645 8.04416 15.855 8.53291 15.3663C9.02166 14.8775 9.81166 14.8775 10.3004 15.3663L13.1667 18.2325L21.0329 10.3663C21.5217 9.8775 22.3117 9.8775 22.8004 10.3663C23.2892 10.855 23.2892 11.645 22.8004 12.1337Z",
		fill: "#4CC474"
	})]
});
const ForwardRef = forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
